import { Component } from '@angular/core';
import { Input, Output, EventEmitter } from '@angular/core';
import { Filter } from '../../../models/filter-models';
import { FormsModule } from '@angular/forms';
import { Tier } from '../../../models/item-data-models';
import { SelectComponent, SelectOptionComponent } from '../select.component';
import { getTierColor, getTierDescription } from '../../helper';

@Component({
  selector: '[app-select-tier]',
  imports: [FormsModule, SelectComponent, SelectOptionComponent],
  templateUrl: './select-tier.component.html',
  styleUrl: './select-tier.component.scss'
})
export class TierSelectorComponent {
  @Input({ required: true }) filter!: Filter;
  @Input() showDescription?: boolean = false;
  @Input() disabled?: boolean;

  private _tier: Tier | undefined = undefined;
  @Input()
  get tier(): Tier | undefined {
    return this._tier;
  }
  @Output() tierChange = new EventEmitter<Tier | undefined>();
  set tier(value: Tier | undefined) {
    this._tier = value;
    this.tierChange.emit(this._tier);
  }

  @Output() tierChanged = new EventEmitter<void>();
  @Output('updateFilter') updateFilterEmitter = new EventEmitter<void>();

  Tier = Tier;

  sTierColor = 'tier-visible-color';
  aTierColor = 'tier-red-color';
  bTierColor = 'tier-orange-color';
  cTierColor = 'tier-yellow-color';
  dTierColor = 'tier-white-color';
  eTierColor = 'tier-visible-color';
  fTierColor = 'tier-hidden-color';

  sTierDescription = '';
  aTierDescription = '';
  bTierDescription = '';
  cTierDescription = '';
  dTierDescription = '';
  eTierDescription = '';
  fTierDescription = '';

  ngOnInit(): void {
    this.sTierColor = getTierColor(this.filter, Tier.SPurple);
    this.aTierColor = getTierColor(this.filter, Tier.ARed);
    this.bTierColor = getTierColor(this.filter, Tier.BOrange);
    this.cTierColor = getTierColor(this.filter, Tier.CYellow);
    this.dTierColor = getTierColor(this.filter, Tier.DWhite);
    this.eTierColor = getTierColor(this.filter, Tier.EVisible);
    this.fTierColor = getTierColor(this.filter, Tier.FHidden);

    this.sTierDescription = getTierDescription(this.filter, Tier.SPurple);
    this.aTierDescription = getTierDescription(this.filter, Tier.ARed);
    this.bTierDescription = getTierDescription(this.filter, Tier.BOrange);
    this.cTierDescription = getTierDescription(this.filter, Tier.CYellow);
    this.dTierDescription = getTierDescription(this.filter, Tier.DWhite);
    this.eTierDescription = getTierDescription(this.filter, Tier.EVisible);
    this.fTierDescription = getTierDescription(this.filter, Tier.FHidden);
  }

  onDisplayTypeChange(newDisplayType: Tier) {
    this.tier = newDisplayType;
    this.tierChange.emit(this.tier);
  }

  updateFilter() {
    this.tierChanged.emit();
    this.updateFilterEmitter.emit();
  }
}
